exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-white{color:#fffdf8!important}.bg-whitex,.q-layout-drawerx,.q-popoverx,.q-tabx{background:#fff!important}.bg-info{background:#287baf!important}.bg-positive{background:#00d1d2!important}.q-table,.text-dark,body{color:#34303d!important}.q-if-label{color:#524f5a!important}.q-input-target,.q-table-bottom,.q-table th{color:#34303d!important}.q-chip{color:#34303d;background:#e1e0e2}.text-red{color:#db3624!important}.q-table tbody td{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7fc0064","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/layouts/default.vue
// module id = Tmpy
// module chunks = 44